import { render } from "./FooterSocialMediaButton.vue?vue&type=template&id=0cb55fac&scoped=true"
import script from "./FooterSocialMediaButton.vue?vue&type=script&lang=js"
export * from "./FooterSocialMediaButton.vue?vue&type=script&lang=js"

import "./FooterSocialMediaButton.vue?vue&type=style&index=0&id=0cb55fac&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cb55fac"]])

export default __exports__